import { Injectable } from "@angular/core";
import { createAction, props } from "@ngrx/store";
import { SoundProfileResponse } from "../types/sound-profile-response";

@Injectable()
export class SoundProfileAction {
  static getSoundProfile = createAction(
    "[SoundProfile:Get] Get Sound Profile",
    props<{ userId: number; parentSoundProfileId: number }>()
  );

  static getSoundProfileWithAdaptive = createAction(
        "[SoundProfile:Get] Get Sound Profile (with feature flag for adaptive)",
        props<{ userId: number; parentSoundProfileId: number }>()
    );

  static getSoundProfileSuccess = createAction(
    "[SoundProfile:Get] Get Sound Profile Success",
    props<{ soundProfile: SoundProfileResponse }>()
  );

  static getSoundProfileFail = createAction(
    "[SoundProfile:Get] Get Sound Profile Fail",
    props<{ error: any }>()
  );

  static addUpdateSoundProfile = createAction(
    "[SoundProfile:Add:Update] Add Update Sound Profile",
    props<{ userId: number; soundProfiles: Array<any> }>()
  );

  static addParentSoundProfile = createAction(
    "[SoundProfile:Add:Parent] Add Parent Sound Profile",
    props<{ userId: number; parentProfileId: number }>()
  );

  static addParentSoundProfileSuccess = createAction(
    "[SoundProfile:Add:Parent] Add Parent Sound Profile Success"
  );

  static addUpdateSoundProfileFail = createAction(
    "[SoundProfile:Add:Update] Add Update Sound Profile Fail"
  );

  static getParentProfiles = createAction(
    "[SoundProfile:Get] Get Parent Profiles"
  );

  static getParentProfilesSuccess = createAction(
    "[SoundProfile:Get] Get Parent Profiles Success",
    props<{ parentProfiles: Array<any> }>()
  );

  static scanAr2VoiceTemplate = createAction(
    "[SoundProfile: Scan] Scan Ar2 Voice Template",
    props<{ userId: number; userName: string }>()
  );

  static scanAr2VoiceTemplateSuccess = createAction(
    "[SoundProfile: Scan] Scan Ar2 Voice Template Success",
    props<{ scannedSoundProfile: Array<any> }>()
  );

  static scanAr2VoiceTemplateFail = createAction(
    "[SoundProfile: Scan] Scan Ar2 Voice Template Fail"
  );

  static addParentSoundProfileAndSaveSounds = createAction(
    "[SoundProfile:Add:Parent] Add Parent Sound Profile And Save Sounds",
    props<{
      userId: number;
      parentProfileId: number;
      soundProfiles: Array<any>;
    }>()
  );

    static openAlertOnAr2Scan = createAction(
        "[SoundProfile: Scan: Alert] Open Alert on AR2 Scan",
        props<{ templatesWithDifferentContent: any }>()
    );
}
